import { Box } from "@material-ui/core";
import React, { useContext } from "react";
import BlackChipTooltip from "../../../../../../../components/Chip/BlackChipTooltip";
import VerticalAlignedChip from "../../../../../../../components/Chip/VerticalAlignedChip";
import { TestSeriesContext } from "../../../../../../../contexts/TestSeriesContext";

const MatrixInputDialogChips: React.FC = () => {
  const { selectedTestSeriesObject } = useContext(TestSeriesContext);

  const productSectionTemplate = () => {
    const { productSection } = selectedTestSeriesObject;
    return productSection.productActionFlows.map(({ id, actionFlow, sideOfProduct }) => {
      return (
        <Box key={id} padding={1}>
          <BlackChipTooltip
            header={actionFlow?.name || ""}
            section="material"
            subHeader={`Side: ${sideOfProduct}`}
            secondaryChips={actionFlow?.actionValues || []}
            optionalChips={productSection.actionsOnAllProducts?.actionValues || []}
          >
            <VerticalAlignedChip label={actionFlow?.name || ""} color="primary" />
          </BlackChipTooltip>
        </Box>
      );
    });
  };

  const substrateSectionTemplate = () => {
    return selectedTestSeriesObject.substrateSections.map(({ substrateActionFlows, actionsOnAllSubstrates }) => {
      return substrateActionFlows.map(({ id, actionFlow }) => {
        if (actionFlow) {
          return (
            <Box key={id} padding={1}>
              <BlackChipTooltip
                header={actionFlow?.name}
                section="substrate"
                secondaryChips={actionFlow?.actionValues || []}
                optionalChips={actionsOnAllSubstrates?.actionValues || []}
              >
                <VerticalAlignedChip label={actionFlow?.name} color="primary" />
              </BlackChipTooltip>
            </Box>
          );
        }
      });
    });
  };

  const specimenTreatmentSectionTemplate = () => {
    const { specimenSection } = selectedTestSeriesObject;
    return specimenSection.treatments.map(({ id, name, actionValues }) => {
      return (
        <Box key={id} padding={1}>
          <BlackChipTooltip
            header={name}
            section="testpiece"
            secondaryChips={actionValues}
            optionalChips={specimenSection.treatmentOnAllSpecimen?.actionValues || []}
          >
            <VerticalAlignedChip label={name} color="primary" />
          </BlackChipTooltip>
        </Box>
      );
    });
  };

  const specimenBuildingActionSectionTemplate = () => {
    const { specimenSection } = selectedTestSeriesObject;
    return specimenSection.buildingActions.map(({ id, name, actionValues }) => {
      return (
        <Box key={id} padding={1}>
          <BlackChipTooltip
            header={name}
            section="testpiece"
            secondaryChips={actionValues}
            optionalChips={specimenSection.buildingActionsOnAllSpecimen?.actionValues || []}
          >
            <VerticalAlignedChip label={name} color="primary" />
          </BlackChipTooltip>
        </Box>
      );
    });
  };

  const conditionSectionTemplate = () => {
    const { conditionSection } = selectedTestSeriesObject;
    return conditionSection.conditions.map((condition) => {
      return (
        <Box key={condition.id} padding={1}>
          <BlackChipTooltip
            header={condition.name}
            section="condition"
            secondaryChips={condition.parameterValues}
            optionalChips={conditionSection.parametersInAllTests || []}
          >
            <VerticalAlignedChip label={condition.name} color="primary" />
          </BlackChipTooltip>
        </Box>
      );
    });
  };
  return (
    <Box display="flex" flexWrap="wrap" paddingBottom={2}>
      {productSectionTemplate()}
      {substrateSectionTemplate()}
      {specimenTreatmentSectionTemplate()}
      {specimenBuildingActionSectionTemplate()}
      {conditionSectionTemplate()}
    </Box>
  );
};

export default MatrixInputDialogChips;
